// extracted by mini-css-extract-plugin
export var actionText = "_mf-4";
export var container = "_mf-0";
export var leftSection = "_mf-1";
export var rightSection = "_mf-2";
export var settingsButton = "_mf-6";
export var settingsIcon = "_mf-7";
export var shortcut = "_mf-5";
export var shortcutGroup = "_mf-3";